import { useState, useEffect } from 'react';
import '../../../entrydoor.css';

// TransomOnLoose — shown when Transom is not None
const OPTIONS = [
  { value: 'On',    label: 'On'    },
  { value: 'Loose', label: 'Loose' },
];

const TransomOnLoose = ({ value = { value: '', label: '' }, onChange, disabled = false }) => {
  const [selected, setSelected] = useState(value?.value || '');

  useEffect(() => { setSelected(value?.value || ''); }, [value?.value]);

  const handleChange = (e) => {
    const v = e.target.value;
    const label = OPTIONS.find(o => o.value === v)?.label || v;
    setSelected(v);
    onChange({ value: v, label });
  };

  return (
    <div className="a-container">
      <label htmlFor="SdTransomOnLoose">Transom On/Loose</label>
      <select id="SdTransomOnLoose" value={selected} onChange={handleChange} disabled={disabled}>
        {OPTIONS.map(o => (
          <option key={o.value} value={o.value}>
            {selected === o.value ? `${o.label} ✔` : o.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default TransomOnLoose;
